// src/client/renderer/character/asset-inventory.ts
// Plan 13 head asset partition — verified at plan-authoring time against assets/manifest.json.
// 8 real heads (placeholder:false, real GLB on disk — cardboard-box + alien assets now authored):
export const PLAN_13_REQUIRED_REAL_HEADS = [
  'chicken',
  'horse',
  'pumpkin',
  'shark',
  'traffic-cone',
  'unicorn',
  'cardboard-box',
  'alien',
] as const;
// Graceful-degrade heads — empty now that all 8 heads are authored and ship as real assets.
// Kept as an export so consumers don't break; the empty list means degradeByName never fires.
export const PLAN_13_GRACEFUL_DEGRADE_HEADS = [] as const;
// Single fallback target. MUST be in PLAN_13_REQUIRED_REAL_HEADS (asserted by tests).
export const PLAN_13_HEAD_FALLBACK_TARGET = 'horse' as const;
// Cape ids (8 textures + 'none' sentinel). All 8 textures verified placeholder:false at plan-authoring.
export const PLAN_13_REQUIRED_CAPE_IDS = [
  'cape-texture-starter',
  'cape-texture-fire',
  'cape-texture-rainbow',
  'cape-texture-cosmic',
  'cape-texture-golden',
  'cape-texture-wireframe',
  'cape-texture-water',
  'cape-texture-lava',
] as const;
